<template>
    <div class="loading-container">
        <Vue3Lottie :animationData="loadingJson" :height="60" :width="60" :loop="true" :autoplay="true" />
    </div>
</template>

<script setup lang="ts">
import { Vue3Lottie } from 'vue3-lottie';
import loadingJson from '../json/all_lottie_loading.json';
</script>

<style scoped lang="scss">
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; // 필요시 변경
}
</style>
